import { Box, Card, Container, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import { styled, useTheme } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import Logo from 'src/components/Logo';
import useAuth from 'src/hooks/useAuth';

import JWTLogin from '../LoginJWT';

const MainContent = styled(Box)(
  () => `
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
);

function LoginBasic() {
  const { t }: { t: any } = useTranslation();
  const theme = useTheme();
  const { method } = useAuth() as any;

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <MainContent>
        <Container maxWidth="sm">
          <Logo size="xs" background={theme.palette.mode} />
          <Card sx={{ mt: 3, p: 4 }}>
            <Box>
              <Typography variant="h2" sx={{ mb: 1 }}>
                {t('Sign in')}
              </Typography>
              <Typography
                variant="h4"
                color="text.secondary"
                fontWeight="normal"
                sx={{ mb: 3 }}
              >
                {t('Fill in the fields below to sign into your account')}
              </Typography>
            </Box>
            {method === 'JWT' && <JWTLogin />}
            <Box my={4}>
              <Typography
                component="span"
                variant="subtitle2"
                color="text.primary"
                fontWeight="bold"
              >
                {t('Don’t have an account yet?')}
              </Typography>{' '}
              <Link
                component={RouterLink}
                underline="hover"
                to="/account/register"
              >
                <b>{t('Sign up here')}</b>
              </Link>
            </Box>
          </Card>
        </Container>
      </MainContent>
    </>
  );
}

export default LoginBasic;
